__turbopack_context__.v({
  "clear-btn": "SearchBar-module-scss-module__UbyCvG__clear-btn",
  "search-bar": "SearchBar-module-scss-module__UbyCvG__search-bar",
  "search-icon": "SearchBar-module-scss-module__UbyCvG__search-icon",
  "search-input": "SearchBar-module-scss-module__UbyCvG__search-input",
  "search-loader-container": "SearchBar-module-scss-module__UbyCvG__search-loader-container",
});
